import React from "react"
import { Link as Internal } from "gatsby"

import External from "./external"

const Link = ({ to, children }) => {
	const external =
		to.indexOf("://") > 0 || to.indexOf("//") === 0 || to.startsWith("mailto")
	return external ? <External to={to}>{children}</External> : <Internal to={to}>{children}</Internal>
}

export default Link
